import cx from 'classnames';
import styles from './RestaurantEventCard.scss';
import {
  RestaurantEventCardContent,
  RestaurantEventStatus,
} from './RestaurantEventCardContent';
import type { RestaurantEvent } from '@shared/types/restaurants';

export interface RestaurantEventCardProps {
  restaurantEvent?: RestaurantEvent | null;
  statusList?: RestaurantEventStatus[];
  onEdit?: () => void;
  children?: React.ReactNode;
  action?: React.ReactNode;
  isPreview?: boolean;
  /** When true, header photos rotate automatically (~3s). Default true. */
  headerImageCarouselAutoAdvance?: boolean;
}

export const RestaurantEventCard = ({
  restaurantEvent,
  onEdit,
  statusList,
  children,
  action,
  isPreview,
  headerImageCarouselAutoAdvance,
}: RestaurantEventCardProps) => {
  const handleEdit = (
    e: React.MouseEvent<HTMLDivElement> | React.KeyboardEvent<HTMLDivElement>,
  ) => {
    e.preventDefault();
    onEdit?.();
  };

  return (
    <div
      className={cx(styles.restaurantEventCard, {
        [styles.clickable]: onEdit,
        [styles.hasChildren]: children,
      })}
      onClick={onEdit ? handleEdit : undefined}
    >
      <RestaurantEventCardContent
        restaurantEvent={restaurantEvent}
        statusList={statusList}
        showDescription={!isPreview}
        action={action}
        headerImageCarouselAutoAdvance={headerImageCarouselAutoAdvance}
      />
      {children && (
        <div className={styles.restaurantEventCardAdditionalInfo}>
          {children}
        </div>
      )}
    </div>
  );
};
